import {BaseDTO} from '../../../utils/base/dto';

export enum SummaryTone {
  FRIENDLY = "FRIENDLY",
  NORMAL = "NORMAL",
  SCIENTIFIC = "SCIENTIFIC"
}

export enum SummaryLength {
  SHORT = "SHORT",
  MEDIUM = "MEDIUM",
  LONG = "LONG"
}

export enum SummaryAccuracy {
  SHORT_PARAGRAPH = "SHORT_PARAGRAPH",
  LONG_PARAGRAPH = "LONG_PARAGRAPH",
  OVERVIEW = "OVERVIEW"
}

export interface SummaryCreateDTO {
  selectedPaperIds: number[];
  name: string;
  selectedTone: SummaryTone;
  selectedLength: SummaryLength;
  selectedAccuracy: SummaryAccuracy;
}

export interface SummaryDTO extends BaseDTO {
  summary: string;
  topic: string;
  projectId: number;

  name: string;
  tone: SummaryTone;
  length: SummaryLength;
  accuracy: SummaryAccuracy;

  paperSummaries: SummaryDocumentDTO[]
}

export interface SummaryChunkDTO extends BaseDTO {
  summary: string;

  chunkNr: number;
  chunkSize: number;
  overlapSize: number;
  paperId: number;
}

export interface SummaryDocumentDTO {
  summary: string;
  chunks: SummaryChunkDTO[];
  paperId: number;
}
